import { Card, Flex, Skeleton } from "antd";
import "./project-card-skeleton.scss";

export function ProjectCardSkeleton() {
  return (
    <Card className="project-card-skeleton">
      <Flex gap={20} vertical>
        <Skeleton.Image className="project-card-skeleton-image" active />
        <Skeleton.Input
          size="small"
          className="project-card-skeleton-details"
          active
        />
        <Skeleton.Input
          size="small"
          block
          className="project-card-skeleton-details"
          active
        />
        <Skeleton.Input
          size="small"
          block
          className="project-card-skeleton-details"
          active
        />
      </Flex>
    </Card>
  );
}
